<template>
  <div>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="300px"
    >
      <template />
      <v-card>
        <v-card-title class="text-body-1">
          <span v-html="firstErrorMsg" />
        </v-card-title>
        <v-card-actions>
          <v-btn
            text
            color="primary"
            @click="showDetail"
          >
            {{ $t('System.ErrorInfo') }}
          </v-btn>
          <v-spacer />
          <v-btn
            text
            color="primary"
            @click="doNotShowDetail"
          >
            {{ $t('PublicServant.Action.Close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="detailDialog"
      persistent
      max-width="800px"
    >
      <template />
      <v-card>
        <v-window
          show-arrows
        >
          <v-window-item
            v-for="(error, i) in httpError"
            :key="i"
          >
            <v-card-text class="text-body-1">
              <p><span class="font-weight-bold">URL:</span> {{ error.config.url }}</p>
              <p><span class="font-weight-bold">status:</span> {{ error.status }}</p>
              <p><span class="font-weight-bold">status text:</span> {{ error.statusText }}</p>
              <p><span class="font-weight-bold">response data:</span> {{ error.data }}</p>
            </v-card-text>
          </v-window-item>
        </v-window>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            color="primary"
            @click="closeDetail"
          >
            {{ $t('PublicServant.Action.Close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { breakSubErrors } from '@/utils/messageUtil'

export default {
  data: () => ({
    dialog: false,
    detailDialog: false
  }),
  computed: {
    ...mapState('global', {
      httpError: state => state.httpError
    }),
    httpErrorLength: function () {
      return this.httpError.length
    },
    firstErrorMsg: function () {
      if (this.httpErrorLength) {
        const tHttpError = this.httpError[0]
        if (tHttpError.status === 400) {
          return this.$chPtObjData('chinMessage', breakSubErrors(tHttpError.data.subErrors))
        } else {
          return this.$t('System.Busy')
        }
      } else {
        return ''
      }
    }
  },
  watch: {
    httpErrorLength: function (val) {
      if (val) {
        this.dialog = true
      }
    }
  },
  methods: {
    showDetail: function () {
      this.dialog = false
      this.detailDialog = true
    },
    closeDetail: function () {
      this.detailDialog = false
      this.$store.commit('global/clearHttpError')
    },
    doNotShowDetail: function () {
      this.dialog = false
      this.$store.commit('global/clearHttpError')
    }
  }
}
</script>
